import { Alert, Box } from '@mui/material';
import { TriangleAlert } from 'lucide-react';

import { Children } from '@/utils/types';

export default function WarningBanner({ children }: Children) {
  return (
    <Box justifyContent="center">
      <Alert
        icon={<TriangleAlert className="text-foreground size-4" />}
        severity="warning"
        sx={{
          height: '32px',
          backgroundColor: 'hint.contrastText',
          color: 'hint.dark',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {children}
      </Alert>
    </Box>
  );
}
